import { useMemo, useState, type ReactElement, type ReactNode } from 'react';

import type { ReimbursementOrigin } from '../routes';
import type { ReimbursementDraft } from '../types';
import { ReimbursementDraftContext } from './reimbursementDraftContext';

const EMPTY_DRAFT: ReimbursementDraft = {
    termsAccepted: false,
    submitted: false,
    partnerFeedback: '',
    proofDocuments: [],
    absenceFrom: '',
    absenceTo: '',
    contactedByPhone: false,
    contactedByEmail: false,
    contactedBySmsOrWhatsApp: false,
};

export type ReimbursementDraftProviderProps = {
    offerRequestLeadUuid: string;
    origin: ReimbursementOrigin;
    children: ReactNode;
};

export function ReimbursementDraftProvider({
    offerRequestLeadUuid,
    origin,
    children,
}: ReimbursementDraftProviderProps): ReactElement {
    const [draft, setDraft] = useState<ReimbursementDraft>(EMPTY_DRAFT);
    const value = useMemo(
        () => ({
            offerRequestLeadUuid,
            origin,
            draft,
            updateDraft: (patch: Partial<ReimbursementDraft>): void =>
                setDraft((current) => ({ ...current, ...patch })),
        }),
        [draft, offerRequestLeadUuid, origin],
    );

    return <ReimbursementDraftContext.Provider value={value}>{children}</ReimbursementDraftContext.Provider>;
}
